/*
 * This code is the intellectual property of Bulb Inc. and other software publishers;
 * it may not be altered, copied or disclosed without prior written approval.
 * Copyright 2017, Bulb Inc.  For more information, please email contact@bulbapp.com.
 */
'use strict';

angular.module('bulbApp.contentEditorModule')

.directive('attachedFileEmbedBlock', attachedFileEmbedBlock);

function attachedFileEmbedBlock() {
    return {
        restrict: 'E',
        controller: 'EmbedBlockController as embedBlockCtrl',
        link: function link(scope, element, attrs, embedBlockCtrl) {
            var unbindWatcher = scope.$watch(function() {
                // Watching for the iframe element to be created:
                return element.find('iframe').length;
            }, function(newLength, oldLength) {
                if (newLength !== oldLength && newLength > 0) {
                    unbindWatcher();
                    embedBlockCtrl.updateBlockSize();
                }
            });
    },
        templateUrl: 'ajs/components/contenteditor/attachedfileembedblock.html'
    };
}
